import { useEffect, type ReactNode } from 'react'
import { Outlet } from 'react-router-dom'

import { AuthError } from '@/features/auth/components/auth-error'
import { AuthLoading } from '@/features/auth/components/auth-loading'
import { ProfileMenu } from '@/features/auth/components/profile-menu'
import { useCurrentUserStore } from '@/features/auth/stores/current-user-store'

const CurrentUserGateShell = ({ children }: { children: ReactNode }) => (
  <div className="flex min-h-dvh flex-col">
    <header className="flex justify-end bg-surface-tint px-8 py-6">
      <ProfileMenu />
    </header>
    <div className="flex flex-1 items-center justify-center p-6">
      {children}
    </div>
  </div>
)

export const CurrentUserRoute = () => {
  const status = useCurrentUserStore((state) => state.status)
  const error = useCurrentUserStore((state) => state.error)
  const load = useCurrentUserStore((state) => state.load)

  useEffect(() => {
    void load()
  }, [load])

  if (status === 'idle' || status === 'loading') {
    return (
      <CurrentUserGateShell>
        <AuthLoading />
      </CurrentUserGateShell>
    )
  }

  if (status === 'error') {
    return (
      <CurrentUserGateShell>
        <AuthError
          error={{ message: error ?? undefined }}
          onRetry={() => void load()}
        />
      </CurrentUserGateShell>
    )
  }

  return <Outlet />
}
